var moment = require('moment');

let parse = (date) => {
    if (!date) {
        return ""
    }

    if (typeof date === 'string') {
        date = new Date(date)
    }

    return date
}

let format = (date) => {
    if (!date) {
        return ""
    }

    date = parse(date)

    return moment(date).format("DD/MM/yyyy HH:mm");
}

let formatNoTime = (date) => {
    if (!date) {
        return ""
    }
    
    date = parse(date)

    return moment(date).format("DD/MM/yyyy");
}

let formatNoTimeDayWeek = (date) => {
	if (!date) {
		return "";
	}
    
    let diaSemana = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
    
    date = parse(date);   

	return `${moment(date).format("DD/MM/yyyy")} - ${diaSemana[date.getDay()]}`;
};

let formatOnlyTime = (date) => {
    if (!date) {
        return ""
    }
    
    date = parse(date)


    return moment(date).format("HH:mm")
}

let formatTime = (time) => {
    if (!time) {
        return ""
    }
    
    let index = time.lastIndexOf(":")

    if (index > 3) {
        return time.substring(0, index)
    }

    return time
}

let getAge = (birthDate) => {
    
    birthDate = parse(birthDate)

    var today = new Date()
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }

    return age;
}


let getDiffTimeFormated = (dateStart, dateEnd) => {
    dateStart = parse(dateStart)
    dateEnd = parse(dateEnd)

    let diff = dateEnd.getTime() - dateStart.getTime()

    let minutes = Math.round( (diff / (1000 * 60)) % 60 )
    let hours = Math.floor( (diff / (1000 * 60 * 60)) )

    return (hours < 10 ? "0" : "") + hours + ":" + (minutes < 10 ? "0" : "") + minutes
}

let getYearOptions = (yearStart, yearEnd, includeEmptyOption) => {
    let anosOptions = []

    if (includeEmptyOption) {
        anosOptions.push({ value: null, text: '(Selecione)'})
    }

    for (let i = yearEnd; i >= yearStart; i--) {
        anosOptions.push({ text : i, value : i })
    }

    return anosOptions
}

let getMonthOptions = (monthStart, monthEnd, includeEmptyOption) => {
    let months = [
        { text : "Janeiro", value : 0 },
        { text : "Fevereiro", value : 1 },
        { text : "Março", value : 2 },
        { text : "Abril", value : 3 },
        { text : "Maio", value : 4 },
        { text : "Junho", value : 5 },
        { text : "Julho", value : 6 },
        { text : "Agosto", value : 7 },
        { text : "Setembro", value : 8 },
        { text : "Outubro", value : 9 },
        { text : "Novembro", value : 10 },
        { text : "Dezembro", value : 11 },
    ]

    let options = months.slice(monthStart || 0, monthEnd || 12)

    if (includeEmptyOption) {
        options.unshift({ value: null, text: '(Selecione)'})
    }

    return options
}

let getMonthByIndex = ( index ) => {
    let months = [
		"Janeiro",
		"Fevereiro",
		"Março",
		"Abril",
		"Maio",
		"Junho",
		"Julho",
		"Agosto",
		"Setembro",
		"Outubro",
		"Novembro",
		"Dezembro",
	];
    
    return months[index]
}

let getMonthAbreviado = ( month ) => {
	let months = [ 
        "Jan", 
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun", 
        "Jul",
        "Ago",
        "Set", 
        "Out",
        "Nov", 
        "Dez"
	];

	return months[month];
}

export default {
	format,
	formatNoTime,
    formatNoTimeDayWeek,
	formatOnlyTime,
	formatTime,
	getAge,
	parse,
	getDiffTimeFormated,
	getYearOptions,
	getMonthOptions,
	getMonthAbreviado,
	getMonthByIndex,
};
